export default __webpack_public_path__ + "static/media/480_dummy2016-weinhandel01-mobile-de.11580180.png";